<div class="consultorio-horario-container">
    @if (isEditing) {
        <app-card-content [headerColor]="false" icon="pi pi-clock" title="Novo Horário de Funcionamento">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div class="rounded-md border border-surface-200 bg-white p-3">
                    <span class="mb-3 block text-sm font-semibold text-color-secondary">Período de Dias</span>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <div>
                            <label class="mb-2 block text-sm font-medium">Dia início</label>
                            <p-select [options]="diasSemanaOptions" [(ngModel)]="diaSemanaInicio" optionLabel="name" optionValue="value" appendTo="body" placeholder="Selecione"></p-select>
                        </div>
                        <div>
                            <label class="mb-2 block text-sm font-medium">Dia fim</label>
                            <p-select [options]="diasSemanaOptions" [(ngModel)]="diaSemanaFim" optionLabel="name" optionValue="value" appendTo="body" placeholder="Selecione"></p-select>
                        </div>
                    </div>
                </div>

                <div class="rounded-md border border-surface-200 bg-white p-3">
                    <span class="mb-3 block text-sm font-semibold text-color-secondary">Turno da Manhã</span>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <div>
                            <label class="mb-2 block text-sm font-medium">Início</label>
                            <p-inputmask mask="99:99" [(ngModel)]="manhaInicio" placeholder="08:00"></p-inputmask>
                        </div>
                        <div>
                            <label class="mb-2 block text-sm font-medium">Fim</label>
                            <p-inputmask mask="99:99" [(ngModel)]="manhaFim" placeholder="12:00"></p-inputmask>
                        </div>
                    </div>
                </div>

                <div class="rounded-md border border-surface-200 bg-white p-3 lg:col-span-2">
                    <span class="mb-3 block text-sm font-semibold text-color-secondary">Turno da Tarde</span>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                        <div>
                            <label class="mb-2 block text-sm font-medium">Início</label>
                            <p-inputmask mask="99:99" [(ngModel)]="tardeInicio" placeholder="13:00"></p-inputmask>
                        </div>
                        <div>
                            <label class="mb-2 block text-sm font-medium">Fim</label>
                            <p-inputmask mask="99:99" [(ngModel)]="tardeFim" placeholder="18:00"></p-inputmask>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4 border-t border-surface-200 pt-3 flex justify-end gap-2">
                <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-text" (onClick)="cancelarCadastroHorario()"></p-button>
                <p-button label="Salvar" icon="pi pi-check" (onClick)="salvarHorario()" [disabled]="loading()"></p-button>
            </div>
        </app-card-content>
    }

    <app-custom-table [data]="horarios()" [metadata]="tableMetadata" [loading]="loading()"></app-custom-table>
    @if (loading()) {
        <div class="mt-2">Carregando horários...</div>
    }
    @if (!loading() && erro()) {
        <div class="mt-2 text-red-500">{{ erro() }}</div>
    }
</div>
